<div class="main-content" *ngIf="contract">
    <div class="container-fluid min-vh-100 d-flex flex-column">
        <div class="row justify-content-between align-items-center">
            <div class="col-12">
                <div class="header">
                    <div class="header-body">
                        <div class="align-items-center row">
                            <div class="col">
                                <h6 class="header-pretitle">Contract</h6>
                                <h1 class="header-title text-truncate notranslate">{{ contract.contractData.name }}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-tab-panel class="d-flex flex-column flex-grow-1" [activeIndex]="routeData?.activeTabIndex">
            <div class="d-flex nav-bar-prefix me-3">
                <a class="nav-link" routerLink="/contracts" style="padding-top: 1rem;">
                    <i class="bi bi-arrow-left"></i>
                </a>
            </div>
            <app-tab-item [templateRef]="detailsRef" routerLink="../details">
                <span class="tab-item">Details</span>
                <ng-template #detailsRef>
                    <div class="tab-content">
                        <app-form (submit)="updateInfo()">
                            <app-contract-info [contract]="contractEntity" [readonly]="!appContext.isAdminOrIntermediary()"></app-contract-info>
                            <div *ngIf="appContext.isAdminOrIntermediary()" class="row mt-4">
                                <div class="col d-flex justify-content-between">
                                    <app-confirmation-toggle>
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h3 class="modal-title">Remove contract</h3>
                                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                        aria-label="Close"></button>
                                            </div>
                                            <div class="modal-body">
                                                <p>Are you sure you want to remove this contract?</p>
                                            </div>
                                            <div class="modal-footer justify-content-between">
                                                <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                                                <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                                                        (click)="deleteContract()">
                                                    Remove contract
                                                </button>
                                            </div>
                                        </div>
                                        <button type="button" class="btn btn-danger">
                                            Delete
                                        </button>
                                    </app-confirmation-toggle>
                                    <button type="submit" class="btn btn-primary">
                                        Save changes
                                    </button>
                                </div>
                            </div>
                        </app-form>
                    </div>
                </ng-template>
            </app-tab-item>
            <app-tab-item [templateRef]="periodsRef" routerLink="../periods">
                <span class="tab-item">Contract Periods</span>
                <ng-template #periodsRef>
                    <div class="tab-content">
                        <app-contract-periods-overview></app-contract-periods-overview>
                    </div>
                </ng-template>
            </app-tab-item>
            <app-tab-item *ngIf="!contract.defaultContract" [templateRef]="linksRef" routerLink="../links">
                <span class="tab-item">Links</span>
                <ng-template #linksRef>
                    <div class="tab-content">
                        <app-linked-contracts-overview></app-linked-contracts-overview>
                    </div>
                </ng-template>
            </app-tab-item>
        </app-tab-panel>
    </div>
</div>
